import { NEWSBOARD_POST_FORM_FIELD_NAME_INSERT_REPLACE } from '../NewsboardPostForm.constants'

import { TemplateConfirmationInsertReplaceOptionValue } from './TemplateConfirmationModal.enums'

export const INITIAL_VALUES = {
  [NEWSBOARD_POST_FORM_FIELD_NAME_INSERT_REPLACE]:
    TemplateConfirmationInsertReplaceOptionValue.Replace,
}
